import React from 'react';

function CreditCard(props: object) {
  return (
    <svg
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M42.875 9.1875H6.125C5.31277 9.1875 4.53382 9.51016 3.95949 10.0845C3.38516 10.6588 3.0625 11.4378 3.0625 12.25V36.75C3.0625 37.5622 3.38516 38.3412 3.95949 38.9155C4.53382 39.4898 5.31277 39.8125 6.125 39.8125H42.875C43.6872 39.8125 44.4662 39.4898 45.0405 38.9155C45.6148 38.3412 45.9375 37.5622 45.9375 36.75V12.25C45.9375 11.4378 45.6148 10.6588 45.0405 10.0845C44.4662 9.51016 43.6872 9.1875 42.875 9.1875ZM42.875 12.25V16.8438H6.125V12.25H42.875ZM42.875 36.75H6.125V19.9062H42.875V36.75ZM39.8125 32.1562C39.8125 32.5624 39.6512 32.9518 39.364 33.239C39.0768 33.5262 38.6874 33.6875 38.2812 33.6875H32.1562C31.7501 33.6875 31.3607 33.5262 31.0735 33.239C30.7863 32.9518 30.625 32.5624 30.625 32.1562C30.625 31.7501 30.7863 31.3607 31.0735 31.0735C31.3607 30.7863 31.7501 30.625 32.1562 30.625H38.2812C38.6874 30.625 39.0768 30.7863 39.364 31.0735C39.6512 31.3607 39.8125 31.7501 39.8125 32.1562ZM27.5625 32.1562C27.5625 32.5624 27.4012 32.9518 27.114 33.239C26.8268 33.5262 26.4374 33.6875 26.0312 33.6875H22.9688C22.5626 33.6875 22.1732 33.5262 21.886 33.239C21.5988 32.9518 21.4375 32.5624 21.4375 32.1562C21.4375 31.7501 21.5988 31.3607 21.886 31.0735C22.1732 30.7863 22.5626 30.625 22.9688 30.625H26.0312C26.4374 30.625 26.8268 30.7863 27.114 31.0735C27.4012 31.3607 27.5625 31.7501 27.5625 32.1562Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CreditCard;
